import React from 'react';
import {each as _each} from 'lodash';
import classnames from "classnames";
import {Button, Icon} from "@gisatcz/ptr-atoms";
import {PresentationMap, ReactLeafletMap} from "@gisatcz/ptr-maps";
import {connects} from "@gisatcz/ptr-state";

import Interferometry from "./Interferometry";
import RiskAssessment from "./RiskAssessment";

import "./style.scss";

const Map = connects.Map(PresentationMap);

class VisualizationsPanel extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    onSectionChange(key) {
        this.props.onSectionChange(key);
    }

    render() {
        const riskClasses = classnames("eo4sdDrrInsarMyanmar20-panel-section eo4sdDrrInsarMyanmar20-risk", {
            active: this.props.activeVisualizationSection === "riskAssessment"
        });

        const interferometryClasses = classnames("eo4sdDrrInsarMyanmar20-panel-section eo4sdDrrInsarMyanmar20-interferometry", {
            active: this.props.activeVisualizationSection === "interferometry"
        });

        // True if some feature is selected in any selection
        let somethingSelected = false;
        if (this.props.selections) {
            _each(this.props.selections, selection => {
                if ( selection?.data?.featureKeysFilter?.keys?.length) {
                    somethingSelected = true;
                }
            })
        }

        return (
            <>
                <div className="eo4sdDrrInsarMyanmar20-visualizations">
                    <div className={riskClasses}>
                        <div className="eo4sdDrrInsarMyanmar20-panel-section-header">Exposure to slope deformation</div>
						{this.props.activeVisualizationSection === "riskAssessment" ? (
							<RiskAssessment/>
						) : (
							<Button className="eo4sdDrrInsarMyanmar20-map-button" onClick={this.onSectionChange.bind(this, "riskAssessment")}>
								<div>
									<Map
										stateMapKey="risk-assessment-small"
										mapComponent={ReactLeafletMap}
									/>
								</div>
							</Button>
						)}

                    </div>
                    {somethingSelected ? (
                        <div className={interferometryClasses}>
                            <div className="eo4sdDrrInsarMyanmar20-panel-section-header">Slope deformation - PSI points</div>
							{this.props.activeVisualizationSection === "interferometry" ? (
								<Interferometry/>
							) : (
								<Button className="eo4sdDrrInsarMyanmar20-map-button" onClick={this.onSectionChange.bind(this, "interferometry")}>
									<div>
										<Map
											stateMapKey="interferometry-small"
											mapComponent={ReactLeafletMap}
										/>
									</div>
								</Button>
							)}
                        </div>
                    ) : null}
                </div>
            </>
        );
    }
}

export default VisualizationsPanel;
